"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUpgradeToken = exports.createUpgradeToken = void 0;
const createUpgradeToken = (upgradeOfferTerms) => {
    return encodeURIComponent(btoa(JSON.stringify(upgradeOfferTerms)));
};
exports.createUpgradeToken = createUpgradeToken;
const parseUpgradeToken = (upgradeToken) => {
    return JSON.parse(atob(decodeURIComponent(upgradeToken)));
};
exports.parseUpgradeToken = parseUpgradeToken;
